
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';

const OnlineOrderInvoice = () => {
  const { id } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const res = await axios.get(`/api/direct-orders/invoice/${id}`);
        setInvoice(res.data);
      } catch (error) {
        console.error('Error fetching invoice:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [id]);

  const handlePrint = () => window.print();

  if (loading) return <p className="p-6">Loading invoice...</p>;
  if (!invoice) return <p className="p-6 text-red-600">Invoice not found</p>;

  const baseTotal = parseFloat(invoice.totalPrice || 0);
  const guaranteeFee = invoice.guarantee ? 5 : 0;
  const promoDiscount = parseFloat(invoice.promoDiscount || 0);
  const finalTotal = (baseTotal + guaranteeFee - promoDiscount).toFixed(2);

  return (
    <div className="print-landscape bg-white mx-auto shadow print:shadow-none px-8 py-4">
      <div className="flex justify-between items-center mb-2">
        <img src="/assets/logo2.png" alt="Logo" className="h-16" />
        <div className="text-right text-xs">
          <h1 className="text-[25px] mb-2 font-bold">MORY GOLD</h1>
          <p className="text-[8px]">Goldsmiths Building, City Center, Erbil, Iraq</p>
          <p className="text-[10px]">+964 751 414 1213</p>
        </div>
      </div>

      <h2 className="text-2xl font-bold mb-3 text-center">Online Order Invoice</h2>

      <div className="grid grid-cols-3 gap-4 text-sm mb-0">
        <div>
          <p><strong>Order ID:</strong> {invoice.orderId}</p>
          <p><strong>Customer Name:</strong> {invoice.customerName}</p>
          <p><strong>Phone:</strong> {invoice.phoneNumber}</p>
        </div>
        <div>
          <p><strong>Date:</strong> {new Date(invoice.orderDate).toLocaleDateString()}</p>
          <p><strong>Address:</strong> {invoice.address || '—'}</p>
        </div>
        {invoice.guarantee !== 'none' && invoice.guarantee !== null && (
          <div className="text-[10px] text-green-600 text-right">
            <QRCodeSVG
              value={
                invoice.items.length === 1
                  ? `https://mory-gold.com/guarantee/direct/${id}/${invoice.items[0]._id}`
                  : `https://mory-gold.com/guarantee/direct/${id}`

              }
              size={70}
              className="mx-auto mt-0.5 mr-0"
            />
            <p className="text-[7px] mt-0.5 text-gray-500">Scan for Guarantee</p>
          </div>
        )}
      </div>


      <table className="w-full border border-gray-300 mb-3 text-sm text-center">
        <thead className="bg-gray-100 text-xs">
          <tr>
            <th className="border px-2 py-1 text-center">Image</th>
            <th className="border px-2 py-1 text-center">Item Name</th>
            <th className="border px-2 py-1 text-center">Product ID</th>
            <th className="border px-2 py-1 text-center">Type</th>
            <th className="border px-2 py-1 text-center">Karat</th>
            <th className="border px-2 py-1 text-center">Weight</th>
            <th className="border px-2 py-1 text-center">Size</th>
            <th className="border px-2 py-1 text-center">Qty</th>
            <th className="border px-2 py-1 text-center">Price (USD)</th>
          </tr>
        </thead>
        <tbody>
          {invoice.items.map((item, idx) => (
            <tr key={idx}>
              <td className="border px-2 py-1 flex justify-center items-center">
                {item.photo ? (
                  <img
                    src={`/uploads/${item.photo.replace(/\\/g, '/')}`}
                    alt="Product"
                    className="w-16 h-16 object-cover rounded"
                  />
                ) : "—"}
              </td>

              <td className="border px-2 py-1">
                <p className="font-semibold">{item.name || '—'}</p>
                {item.description && (() => {
                  const cleanText = item.description.replace(/<[^>]+>/g, '');
                  const maxLength = 200; // ✅ adjust for your needs
                  const shortText = cleanText.length > maxLength
                    ? cleanText.substring(0, maxLength) + "..."
                    : cleanText;

                  return (
                    <p className="text-[9px] leading-tight text-gray-600">
                      {shortText}
                    </p>
                  );
                })()}

              </td>
              <td className="border px-2 py-1">{item.productId || '—'}</td> {/* ✅ clearly added */}


              <td className="border px-2 py-1">
                {item.productType && item.productType.length ? item.productType.join(', ') : '—'}
              </td>

              <td className="border px-2 py-1">21K</td>

              <td className="border px-2 py-1">
                {item.weight !== undefined && item.weight !== null ? `${item.weight}g` : '—'}
              </td>
              <td className="border px-2 py-1">{item.size ? item.size : 'Default'}</td>
              <td className="border px-2 py-1">{item.quantity || 1}</td>
              <td className="border px-2 py-1">${parseFloat(item.price).toFixed(2)}</td>
            </tr>
          ))}

          {invoice.guarantee && (
            <tr className="bg-green-50 text-green-800 font-semibold">
              <td className="border px-2 py-1" colSpan={8}>
                1-Year Guarantee
              </td>
              <td className="border px-2 py-1">$5.00</td>
            </tr>
          )}
          {invoice.promoDiscount > 0 && (
            <tr className="bg-green-50 text-green-800 font-semibold">
              <td className="border px-2 py-1" colSpan={8}>
                Promo Discount
              </td>
              <td className="border px-2 py-1">-${parseFloat(invoice.promoDiscount).toFixed(2)}</td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="text-right text-lg font-semibold mb-6 text-black">

        <p>Total: ${finalTotal}</p>

      </div>

      <div className="flex justify-end print:hidden">
        <button
          onClick={handlePrint}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Print Invoice
        </button>
      </div>
    </div>
  );
};

export default OnlineOrderInvoice;
